import { Button, Col, Divider, Row } from "antd";
import { ReactNode, useEffect, useState } from "react";

import colSettingSvg from "src/shared/assets/svg/icon/colSetting.svg";
import exportSvg from "src/shared/assets/svg/icon/export.svg";
import searchSvg from "src/shared/assets/svg/newDesign/search.svg";
import filterSvg from "src/shared/assets/svg/newDesign/filter.svg";
import favSvg from "src/shared/assets/svg/newDesign/fav.svg";
import dragSvg from "src/shared/assets/svg/icon/drag.svg";

import useDirection from "src/shared/hooks/useDirection";
import { ColumnsType } from "antd/lib/table";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import useFilter from "src/shared/hooks/useFilter";
import { useHistory } from "react-router-dom";
import { queryParse } from "src/shared/function/queryParse";
import useRequest from "src/shared/hooks/useRequest";
import useDate from "src/shared/hooks/useDate";
import { InputComponentProps } from "src/shared/components/InputC/Input.Component";
import {
  ButtonC,
  CardC,
  FormC,
  IconC,
  InputC,
  ModalC,
  SwitchC,
} from "src/shared/components";
import "./index.filter.less";
import useSWR from "swr";

interface TableFilterCProps {
  children?: ReactNode;
  searchProps?: InputComponentProps;
  newColumns?: ColumnsType<any>;
  setNewColumns: React.Dispatch<
    React.SetStateAction<ColumnsType<any> | undefined>
  >;
  columnName?: string;
  exportApi?: any;
}
const TableFilterCPublic = (TableFilterCProps: TableFilterCProps) => {
  const {
    children,
    newColumns,
    searchProps,
    setNewColumns,
    columnName,
    exportApi,
  } = TableFilterCProps;
  const { styler } = useDirection();
  const { t } = useTranslation();
  const { onFilter, onReset } = useFilter();
  const {
    push,
    location: { search },
  } = useHistory();
  const { onGet, loading, onDownload } = useRequest();
  const { toLocalDateAndTimeString } = useDate();
  const [modalVisible, setModalVisible] = useState({ colSetting: false });
  const [switchChange, setSwitchChange] = useState<any>(newColumns);

  const [searchWidth, setSearchWidth] = useState(2);

  useEffect(() => {
    setSwitchChange(newColumns);
  }, [JSON.stringify(newColumns)]);
  const query = queryParse(search);
  const showColHandler = (title: any, show: boolean) => {
    let oldSetting = switchChange;
    let newSetting = oldSetting?.map((item: any) =>
      item.title == title ? { ...item, show } : item
    );
    // localStorage.setItem(
    //   columnName,
    //   JSON.stringify(
    //     newSetting
    //       ?.filter((item: any) => item.show)
    //       .map((item: any) => item.dataIndex)
    //   )
    // );
    setSwitchChange(newSetting);
    // setNewColumns(newSetting);
  };

  const resetSetting = () => {
    setNewColumns(newColumns?.map((item) => ({ ...item, show: true })));
    columnName && localStorage.removeItem(columnName);
    // setModalVisible({ colSetting: false });
  };

  const { data: categoryData } = useSWR(`/category/select`);

  //   const saveSetting = () => {
  //     const keys = switchChange
  //       ?.filter((item: any) => item.show)
  //       .map((item: any) => item.dataIndex);

  //     columnName && localStorage.setItem(columnName, JSON.stringify(keys));

  //     setNewColumns(switchChange);
  //     onFilter({ fields: keys });
  //     setModalVisible({ colSetting: false });
  //   };

  return (
    <Row justify="center" align="middle" className="rowMaintableFilterPublic">
      <Col span={24}>
        <CardC style={{ borderTopWidth: "0px", width: "100%" }}>
          <Row justify="center">
            <Col span={24}>
              <FormC>
                <Row align="middle" justify="start" gutter={[10, 10]}>
                  <InputC
                    col={{ xs: searchWidth }}
                    placeholder={t("search")}
                    onFocus={() => {
                      setSearchWidth(6);
                    }}
                    onBlur={() => {
                      setSearchWidth(2);
                    }}
                    autoComplete="off"
                    className="search"
                    formItem={{
                      label: "",
                      initialValue: query?.keyword,
                      name: "keyword",
                    }}
                    prefix={<img src={searchSvg} />}
                    onPressEnter={(e: any) => {
                      e.preventDefault();
                      onFilter({ keyword: e.target.value });
                    }}
                    {...searchProps}
                  />

                  <Col>
                    <ButtonC className="filter">
                      <img src={filterSvg} />
                      <span
                        style={{ display: "inline-block", margin: "0 5px" }}
                      ></span>
                      {t("Filters")}
                    </ButtonC>
                  </Col>

                  <Col>
                    <ButtonC className="filter">
                      <img src={favSvg} />
                      <span
                        style={{ display: "inline-block", margin: "0 5px" }}
                      ></span>
                      {t("Fav")}
                    </ButtonC>
                  </Col>

                  <Divider type="vertical" />
                  <Col>
                    <ButtonC
                      className="filter"
                      style={{
                        padding: "0 25px",
                        background: "#F0F6FF",
                        color: "#3861FB",
                      }}
                    >
                      {t("All")}
                    </ButtonC>
                  </Col>

                  {categoryData
                    ? categoryData?.map(
                        (i: any) =>
                          i?.name && (
                            <Col>
                              <span className="allFavItems">{i?.name}</span>
                            </Col>
                          )
                      )
                    : null}

                  {/* <Col xs={24} md={12} lg={10}>
                    <Row justify="space-between" gutter={[10, 10]}>
                      <Col xs={24} lg={8}>
                        <ButtonC
                          type="default"
                          icon={
                            <IconC
                              type="ReloadOutlined"
                              // style={{ ...styler({ marginLeft: "8px" }) }}
                            />
                          }
                          onClick={onReset}
                        >
                          {t("reset all filters")}
                        </ButtonC>
                      </Col>
                    </Row>
                  </Col> */}
                </Row>
              </FormC>
            </Col>
            <Col span={24}> {children}</Col>
          </Row>
        </CardC>
      </Col>
    </Row>
  );
};

export default TableFilterCPublic;
